import { Pipe, PipeTransform } from '@angular/core';

type ElementClassMapping = Record<string, string>;

export const addClassesToHtml = (html: string, elementClassMap: ElementClassMapping): string => {
  if (!html || !elementClassMap) {
    return html;
  }

  return Object.entries(elementClassMap).reduce((currentHtml, [selector, className]) => {
    const regex = new RegExp(`(<${selector}(\\s[^>]*)?>)`, 'gi');

    return currentHtml.replace(regex, (match) => {
      if (match.includes('class="')) {
        return match.replace(/class="([^"]*)"/, (_, existingClasses) => {
          return `class="${existingClasses} ${className}"`;
        });
      } else {
        return match.replace('>', ` class="${className}">`);
      }
    });
  }, html);
};

@Pipe({
  name: 'finAddClasses',
  pure: true,
  standalone: false,
})
export class AddClassesPipe implements PipeTransform {
  transform(html: string, elementClassMap: ElementClassMapping): string {
    return addClassesToHtml(html, elementClassMap);
  }
}
